import { Component, Input, Output, EventEmitter } from '@angular/core';
import {
  StringValueAccessor,
  CreateStringValueAccessorProvider,
  CreateStringValueValidationProvider,
} from '../../shared/widgets/value-accessors/string-value-accessor';

/**
 * @whatItDoes Select time input
 * @howToUse `<wl-time-selector inputCssClass="form-control" name="startTime" [(ngModel)]="event.StartTime"></wl-time-selector>`
 * @description
 *
 * A dropdown list of times, starting at 7:00 am, incrementing at 15 minute steps, each label run through a translator for locale formatting.
 * The value returned is not: military time string WITH leading 0 for times less than 10 am.
 * The value returned is now: the same value you see in the dropdown.
 *
 * ### Examples
 * <wl-time-selector inputCssClass="form-control" name="startTime" [(ngModel)]="event.StartTime"></wl-time-selector>
 */
@Component({
  selector: 'wl-time-selector',
  templateUrl: 'time-selector.component.html',
  standalone: false,
  providers: [CreateStringValueAccessorProvider(TimeSelectorComponent), CreateStringValueValidationProvider(TimeSelectorComponent)],
})
export class TimeSelectorComponent extends StringValueAccessor {
  @Input() public required: any;
  @Input() public inputCssClass: string = '';
  @Input() public blankLabel: string = '';
  @Input() public noonLabel: string = '';
  @Input() public midnightLabel: string = '';

  public timeValues: Date[] = [];

  public _hourMinutes: Array<Array<number>> = [
    [7, 0],
    [7, 15],
    [7, 30],
    [7, 45],
    [8, 0],
    [8, 15],
    [8, 30],
    [8, 45],
    [9, 0],
    [9, 15],
    [9, 30],
    [9, 45],
    [10, 0],
    [10, 15],
    [10, 30],
    [10, 45],
    [11, 0],
    [11, 15],
    [11, 30],
    [11, 45],
    [12, 0],
    [12, 15],
    [12, 30],
    [12, 45],
    [13, 0],
    [13, 15],
    [13, 30],
    [13, 45],
    [14, 0],
    [14, 15],
    [14, 30],
    [14, 45],
    [15, 0],
    [15, 15],
    [15, 30],
    [15, 45],
    [16, 0],
    [16, 15],
    [16, 30],
    [16, 45],
    [17, 0],
    [17, 15],
    [17, 30],
    [17, 45],
    [18, 0],
    [18, 15],
    [18, 30],
    [18, 45],
    [19, 0],
    [19, 15],
    [19, 30],
    [19, 45],
    [20, 0],
    [20, 15],
    [20, 30],
    [20, 45],
    [21, 0],
    [21, 15],
    [21, 30],
    [21, 45],
    [22, 0],
    [22, 15],
    [22, 30],
    [22, 45],
    [23, 0],
    [23, 15],
    [23, 30],
    [23, 45],
    [0, 0],
    [0, 15],
    [0, 30],
    [0, 45],
    [1, 0],
    [1, 15],
    [1, 30],
    [1, 45],
    [2, 0],
    [2, 15],
    [2, 30],
    [2, 45],
    [3, 0],
    [3, 15],
    [3, 30],
    [3, 45],
    [4, 0],
    [4, 15],
    [4, 30],
    [4, 45],
    [5, 0],
    [5, 15],
    [5, 30],
    [5, 45],
    [6, 0],
    [6, 15],
    [6, 30],
    [6, 45],
  ];

  public constructor() {
    super();

    let today = new Date();

    // build time values off today so there is no daylight savings shift
    this._hourMinutes.forEach(x => {
      var hour = x[0];
      var minute = x[1];

      // build time value off today
      this.timeValues.push(new Date(today.getFullYear(), today.getMonth(), today.getDate(), hour, minute, 0));
    });
  }
}
